import { tracking } from '@dashboard/lib/tracking';

export function trackResultClick(params: { group: string; rank: number; queryLength: number }) {
  tracking.trackEvent('command_palette_result_clicked', {
    group: params.group,
    rank_in_group: params.rank,
    query_length: params.queryLength,
  });
}
